import React from 'react';
import { Trans } from 'react-i18next';
import { Image, Stack } from '@fluentui/react';
import { IStyledComponent } from 'common/Common.types';
import { Link } from 'common/components/Link';
import { Text } from 'common/components/Text';
import { ImageConstants } from 'common/ImageConstants';
import { getAssetPath } from 'common/utilities/AssetsPath';
import { MicrosoftPrivacyURL } from 'common/utilities/URLConstants';
import { useLocalizedStrings } from 'i18n';

import { chatTokens, useChatControlStyles } from './Chat.styles';

interface ICopilotStarter extends IStyledComponent {}

// i18next-extract-mark-ns-start copilot
export const CopilotStarter = (props: ICopilotStarter) => {
  const { styles, className } = props;
  const copilotLogo = getAssetPath(ImageConstants.CopilotPreview);
  const { t } = useLocalizedStrings('copilot');
  const classNames = useChatControlStyles();

  return (
    <Stack tokens={chatTokens.copilotStarterRoot} className={className} styles={styles}>
      <Stack verticalAlign="center" horizontalAlign="center">
        <Image src={copilotLogo} alt="" width={72} />
        <Text block className={classNames.copilotStarterHeading} variant="Title2">
          {t('ChatControl.CopilotStarter.Heading')}
        </Text>
        <Text block variant="Body1" className={classNames.copilotStarterSubheading}>
          {t('ChatControl.CopilotStarter.Subheading')}
        </Text>
      </Stack>
      <Stack.Item>
        <Text variant="Caption2">
          <Trans
            i18nKey="ChatControl.CopilotStarter.Disclaimer"
            components={{
              sendFeedbackBtn: (
                <Link
                  href={MicrosoftPrivacyURL}
                  target="_blank"
                  aria-label={t('ChatControl.CopilotStarter.SendFeedback')}
                  telemetryEventName="ChatControl.SendFeedback"
                />
              ),
            }}
            t={t}
          />
        </Text>
      </Stack.Item>
    </Stack>
  );
};
// i18next-extract-mark-ns-stop copilot
